import { render } from "./Episodes.vue?vue&type=template&id=45cf8a28&scoped=true"
import script from "./Episodes.vue?vue&type=script&lang=js"
export * from "./Episodes.vue?vue&type=script&lang=js"

import "./Episodes.vue?vue&type=style&index=0&id=45cf8a28&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cf8a28"]])

export default __exports__